




























import Vue from 'vue';

import {
  Component,
  Prop,
} from 'vue-property-decorator';

import {
  defaultTable,
  WorkTypeModel,
} from '@/components/RatesPage/types';

import RatesTable from '@/components/RatesPage/RatesTable.vue';
import _ from 'lodash';

@Component({
  components: {
    RatesTable,
  },
})
export default class RatesSheet extends Vue {
  @Prop({
    type: Object,
    default: false,
  }) readonly workType!: WorkTypeModel;

  @Prop()
  readonly suppliers!: any;

  usedWorkType = this.workType;

  get availableSuppliers() {
    return this.suppliers.filter((supplier: any) => {
      const supplierId = supplier.id;
      return !this.usedWorkType.sheets?.some((sheet: any) => sheet.suppliers.some((sId: any) => sId === supplierId));
    }).map((sup: any) => sup.id);
  }

  refreshSuppliers(value: any) {
    this.$emit('refreshSuppliers', value);
  }

  deleteTariff(key: any) {
    if (this.usedWorkType?.sheets) {
      const item = this.usedWorkType.sheets.findIndex((v_rt: any) => v_rt.key === key.toString());
      this.$delete(this.usedWorkType.sheets, item);
    }
  }

  createSheet() {
    /** TODO [m.kudryashov 15.04.2023 - 12:53]:
    * вынести в дефолтный sheet
    */
    const sheet = {
      cells: _.cloneDeep(defaultTable),
      key: Math.random().toString().substring(2),
      suppliers: [],
    };

    this.$emit('createRateTable', sheet);
  }

  changeRateTable(value: any) {
    this.$emit('changeRateTable', value);
  }

  updateComment(value: any) {
    this.$emit('updateComment', value);
  }
}

